import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const DogTraining = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my dog training business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps dog training businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for dog training businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most dog training businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my dog training business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like dog training. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Dog Training - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Dog Training CRM", url: "/industries/dog-training" }
  ];

  const industryData = {
    name: 'Dog Training',
    title: 'Fill Group Classes & Build Long-Term Training Clients',
    subtitle: 'Automate class enrollment, send training reminders, and convert basic obedience to advanced programs',
    icon: '🐕',
    challenges: [
      'Group classes don\'t fill consistently',
      'One-time clients don\'t continue training',
      'Hard to follow up on behavioral consults',
      'Scheduling private sessions is chaotic',
      'Difficult to upsell advanced training'
    ],
    solutions: [
      'Automated class enrollment campaigns',
      'Training progression tracking',
      'Behavioral consult follow-ups',
      'Online booking for private sessions',
      'Advanced program upsell automation'
    ],
    features: [
      'Client CRM with dog profiles',
      'Class enrollment automation',
      'Training progress tracking',
      'Session booking system',
      'Homework reminder automation',
      'Video training resources',
      'Package management',
      'Review automation'
    ],
    results: [
      '90% class capacity',
      '70% continue to advanced training',
      'Book 50% more private sessions',
      '£4.2K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Dog Training UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for dog training businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for dog training UK, dog training business software, dog training customer management, dog training lead generation UK"
        url="/industries/dog-training"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default DogTraining;